<template>
  <svg
    :class="size"
    class="inline"
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.57143 1H4.42857C2.53502 1 1 2.49238 1 4.33332V11"
      :stroke="$primaryColor"
      stroke-width="1.5"
    />
    <path
      d="M4.32141 8.08332C4.32141 7.08807 4.32259 6.40618 4.38284 5.88658C4.44118 5.38351 4.54648 5.12651 4.69151 4.94275C4.78742 4.82123 4.89976 4.71188 5.02592 4.61776C5.22054 4.47257 5.494 4.36766 6.01904 4.31011C6.55787 4.25106 7.26348 4.25 8.2857 4.25C9.30791 4.25 10.0135 4.25106 10.5524 4.31011C11.0774 4.36766 11.3509 4.47257 11.5455 4.61776C11.6716 4.71188 11.784 4.82123 11.8799 4.94275C12.0249 5.12651 12.1302 5.38351 12.1886 5.88658C12.2488 6.40618 12.25 7.08807 12.25 8.08332V11.4166C12.25 12.4119 12.2488 13.0938 12.1886 13.6134C12.1302 14.1165 12.0249 14.3735 11.8799 14.5572C11.784 14.6787 11.6716 14.7881 11.5455 14.8822C11.3509 15.0274 11.0774 15.1323 10.5524 15.1899C10.0135 15.2489 9.30791 15.25 8.2857 15.25C7.26348 15.25 6.55787 15.2489 6.01904 15.1899C5.49399 15.1323 5.22054 15.0274 5.02592 14.8822C4.89976 14.7881 4.78742 14.6787 4.69151 14.5572C4.54648 14.3735 4.44118 14.1165 4.38284 13.6134C4.32259 13.0938 4.32141 12.4119 4.32141 11.4166V8.08332Z"
      :stroke="$primaryColor"
      stroke-width="1.5"
    />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'h-4 w-4'
    }
  }
}
</script>
